// Applies a brand's text rewrites (brands/index.js) to copy written for VoiceArchive:
// its company name, website links and e-mail addresses. A brand without rewrites gets
// its input back untouched, so VoiceArchive renders exactly as it always has.

export const rebrandText = (brand, text) => {
  if (typeof text !== 'string' || !brand?.rewrites?.length) {
    return text
  }

  return brand.rewrites.reduce(
    (result, [pattern, replacement]) => result.replace(pattern, replacement),
    text
  )
}

const messageCache = new WeakMap()

// Rewrites a whole message table. Cached per brand and table, because the table is
// rebuilt on every locale switch and holds about a thousand strings.
export const rebrandMessages = (brand, messages) => {
  if (!messages || !brand?.rewrites?.length) {
    return messages
  }

  let byTable = messageCache.get(brand)
  if (!byTable) {
    byTable = new WeakMap()
    messageCache.set(brand, byTable)
  }

  if (!byTable.has(messages)) {
    byTable.set(
      messages,
      Object.fromEntries(
        Object.entries(messages).map(([id, text]) => [
          id,
          rebrandText(brand, text),
        ])
      )
    )
  }

  return byTable.get(messages)
}
